import React, { useEffect, useState } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { useFormik } from 'formik';
import { updateProject, resendInviteEmailonMember, checkUserEmail } from '../../../../actions/projectActions'
import { getMembers } from "../../../../actions/memberActions";
import { MEMBER } from '../../../../constants/constants';
import * as actionTypes from '../../../../constants/userActionTypes'
import { VALIDATE_EMAIL } from '../../../../constants/constants'
import * as Yup from "yup";
import moment from 'moment';
import AddMemberModal from '../../../Members/AddMemberModal'

const Details = (props) => {

    const dispatch = useDispatch();
    const [projectId, setProjectId] = useState();
    const [endDate, setEndDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());
    // const [campaign_id, setCampaignId] = useState(null);
    // const [campaignListType, setCampaignListType] = useState(true);
    const [isPartnerDisabled, setIsPartnerDisabled] = useState(false);
    const [currentPartners, setCurrentPartners] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    // const [partnerEmail, setPartnerEmail] = useState([]);
    // const [workingGroups, setWorkingGroup] = useState([]);
    const [showAddAdminModal, setAddAdminModal] = useState(false);
    const [selectedRowData, setselectedRowData] = useState(false);
    const [searchEmail, setSearchEmail] = useState([]);
    const [currentPartnerEmail, setCurrentPartnerEmail] = useState();
    const [selectedPartners, setSelectedPartners] = useState([{ id: '', email: '' }]);
    const [removePartners, setRemovePartners] = useState([]);
    const [removeMembers, setRemoveMembers] = useState([]);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);

    const { campaigns, loading, userEmails } = useSelector(state => state.projectStore);
    const { members } = useSelector(state => state.memberStore);
    const { user } = useSelector(state => state.auth);

    const formik = useFormik({
        initialValues: {
            title: '',
            job_number: '',
            partner: '',
            project_start_date: '',
            project_end_date: '',
            campaigns: [],
            partner_emails: [],
            member_emails: '',
            delete_members: [],
            delete_partners: [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            title: Yup.string().required('Title is requied'),
            job_number: Yup.string().required('Project id is requied').matches(/^[a-zA-Z0-9]+$/, "Project id is invalid"),
            partner: Yup.string().matches(VALIDATE_EMAIL, "Email is not valid"),
            member_emails: Yup.array().required("members is required").min(1, 'members is required'),
            partner_emails: Yup.array().required("partner is required").min(1, 'partner is required'),
            campaigns: Yup.array(),
            project_start_date: Yup.date().required('Start date is required'),
            project_end_date: Yup.date().min(Yup.ref("project_start_date"), "End date has to be more than start date"),
        }),
        onSubmit: (value, { resetForm }) => {
            const formData = {
                id: projectId,
                title: value.title,
                job_number: value.job_number,
                member_emails: value.member_emails,
                partner_emails: value.partner_emails,
                // campaign_id : value.campaign_id,
                campaigns: value.campaigns,
                project_start_date: value.project_start_date,
                project_end_date: value.project_end_date,
                delete_members: value.delete_members,
                delete_partners: value.delete_partners,
            }
            console.log('Update project values', formData)
            dispatch(updateProject(formData))
            //resetForm();
        },
    });

    useEffect(() => {
        dispatch(getMembers())
        if (props.data) {
            // console.log('update details page console',props)
            formik.setFieldValue('title', props.data?.title)
            formik.setFieldValue('job_number', props.data?.job_number)
            formik.setFieldValue('project_start_date', props.data?.project_start_date)
            formik.setFieldValue('project_end_date', props.data?.project_end_date)
            formik.setFieldValue('campaigns', props.data?.references)
            formik.setFieldValue('partner_emails', props.data?.partners)
            formik.setFieldValue('member_emails', props.data?.members)

            setStartDate(new Date(props.data?.project_start_date))
            setEndDate(new Date(props.data?.project_end_date))
            // setCampaignId(props.data?.campaign_id)
            setSelectedCampaigns(props.data?.references)
            setProjectId(props.data?.id)
            setSelectedMembers(props.data?.members)
            setCurrentPartners(props.data?.partners)
            setSelectedPartners(props.data?.partners);
        }
    }, [dispatch ,props.data])

    useEffect(() => {
        if (userEmails) {
            dispatch({ type: actionTypes.CHECK_USER_BY_EMAIL_RESET })
        }
        if (userEmails) {
            setSearchEmail(userEmails);
        }
    }, [dispatch, userEmails])

    useEffect(() => {

        if (currentPartners) {
            var isPartners
            const result = currentPartners?.find(function (value) {
                if (value.id === user.user_id) return isPartners = value;
                return value;
            });
            if (isPartners) {
                setIsPartnerDisabled(true)
            }
            return result;
        }

    }, [currentPartners, user])

    // const changeCampaignType = (data) => {
    //     let value = data ? true : false;
    //     //console.log(value);
    //     setCampaignListType(value)
    //     formik.setFieldValue('isCampaign', value)
    // }

    
    const onSelectStartDate = (date) => {
        formik.setFieldValue('project_start_date', moment(date).format('YYYY-MM-DD'))
        setStartDate(date)
    }
    const onSelectEndDate = (date) => {
        formik.setFieldValue('project_end_date', moment(date).format('YYYY-MM-DD'))
        setEndDate(date)
    }

    const onResendInvite = (id) => {
        dispatch(resendInviteEmailonMember(id))
    }
    const onSelectMembers = (selectedList, selectedItem) => {
        const memberData = selectedList.map(function (item) {
            const value = { id: item.id, email: item.email }
            return value
        });
        //const selectedNewItem = {id: selectedItem.id, email: selectedItem.email }
        //const removeMembersList = [...removeMembers, selectedNewItem];
        const removeEmailFromState = removeMembers.filter(item => item.email !== selectedItem.email)
        //console.log(removeEmailFromState, 'remove dublicates');
        //const unique = Array.from(new Set(removeMembersList.map(JSON.stringify))).map(JSON.parse);
        formik.setFieldValue('delete_members', removeEmailFromState)
        setRemoveMembers(removeEmailFromState);
        formik.setFieldValue('member_emails', memberData)
    }

    const onRemoveMembers = (selectedList, removedItem) => {
        const memberData = selectedList.map(function (item) {
            const removeMember = { id: item.id, email: item.email }
            return removeMember;
        });
        const removeItem = { id: removedItem.id, email: removedItem.email }
        //console.log(removeItem, 'delete value')
        const removeMembersList = [...removeMembers, removeItem];
        const unique = Array.from(new Set(removeMembersList.map(JSON.stringify))).map(JSON.parse);
        formik.setFieldValue('delete_members', unique)
        setRemoveMembers(unique);

        formik.setFieldValue('member_emails', memberData)
    }
    const handleAddAdminClose = () => {
        setAddAdminModal(false);
        setselectedRowData(false);
    };
    const handleAddMemberShow = () => {
        setselectedRowData(false);
        setAddAdminModal(true);
    };
    const onChangeEmail = (e) => {
        let email = e.target.value;
        let result = email.includes("@");
        if (result) {
            dispatch(checkUserEmail(email))
        } else {
            setSearchEmail([])
        }
        // console.log(email);
        setCurrentPartnerEmail(e.target.value)
        formik.setFieldValue('partner', e.target.value)
    }

    const AddToPartnerEmail = (email) => {
        setCurrentPartnerEmail('')
        let isValid = VALIDATE_EMAIL.test(email);
        if (isValid) {
            const chatHistoryList = [...selectedPartners, { id: '', email: email }]; // new array need to update
            const unique = Array.from(new Set(chatHistoryList.map(JSON.stringify))).map(JSON.parse);
            setSelectedPartners(unique); // update the state
            formik.setFieldValue('partner_emails', unique)
            formik.setFieldValue('partner', '')
            setSearchEmail([])
        }

    };

    const onRemoveEmail = (email) => {
        const removeEmail = selectedPartners.filter(item => item.email !== email.email)

        selectedPartners.map(function (item) {
            const value = { id: item.id, email: item.email }
            if (item.email === email.email && item.id !== '') {
                const chatHistoryList = [...removePartners, value];
                const unique = Array.from(new Set(chatHistoryList.map(JSON.stringify))).map(JSON.parse);
                console.log(unique, 'removed items')
                formik.setFieldValue('delete_partners', unique)
                setRemovePartners(chatHistoryList);
            }
            return value;
        });

        setSelectedPartners(removeEmail); // update the state
        formik.setFieldValue('partner_emails', removeEmail)
        // console.log(removeEmail, 'in remove button')
    }
    const onSelectReferences = (selectedList) => {
        formik.setFieldValue('campaigns', selectedList)
    }

    const onRemoveReferences = (selectedList) => {
        formik.setFieldValue('campaigns', selectedList)
    }
    return (
        <>
            <form className="form-auth-small" onSubmit={formik.handleSubmit}>
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-radius">
                            <div className="header card-header custum-bg-warning rounded">
                                <h2 className="text-white">Details</h2>
                            </div>
                            <div className="body card-body-shadow">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="title" className="control-label">Brief Title<span className='text-danger'>*</span></label>
                                            <input type="text" placeholder='Enter Brief Title' name="title" id="title" {...formik.getFieldProps('title')} className="form-control" />
                                            {formik.touched.title && formik.errors.title ? (
                                                <div className="text-danger pt-2">{formik.errors.title}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Job Number</label>
                                            <input type="text" disabled id="job_number" placeholder='Enter Job Number' name='job_number'  {...formik.getFieldProps('job_number')} className="form-control" />
                                            {formik.touched.job_number && formik.errors.job_number ? (
                                                <div className="text-danger pt-2">{formik.errors.job_number}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="title" className="control-label">Start Date<span className='text-danger'>*</span></label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => onSelectStartDate(date)}
                                                name="project_end_date"
                                                id="project_end_date"
                                                className="form-control" />
                                            {formik.touched.project_start_date && formik.errors.project_start_date ? (
                                                <div className="text-danger pt-2">{formik.errors.project_start_date}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="title" className="control-label">End Date<span className='text-danger'>*</span></label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => onSelectEndDate(date)}
                                                name="project_end_date"
                                                id="project_end_date"
                                                className="form-control" />
                                            {formik.touched.project_end_date && formik.errors.project_end_date ? (
                                                <div className="text-danger pt-2">{formik.errors.project_end_date}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-radius">
                            <div className="header card-header custum-bg-warning rounded">
                                <h2 className="text-white">Working group</h2>
                            </div>
                            <div className="body card-body-shadow">
                                <div className='row'>
                                    <div className="col-lg-11 col-md-11 col-sm-11">
                                        <div className="form-group">
                                            <label htmlFor="partner" className="control-label">Current Partners<span className='text-danger'>*</span></label>
                                            <input
                                                {...formik.getFieldProps('partner')}
                                                name='partner'
                                                type={'email'}
                                                placeholder='Please Enter Email'
                                                className="form-control"
                                                onChange={onChangeEmail}
                                                defaultValue={currentPartnerEmail}
                                                disabled={isPartnerDisabled}
                                            />
                                            <ul className='custom-search'>
                                                {searchEmail ? searchEmail.map((email, index) => (<li onClick={() => AddToPartnerEmail(email.email)} key={index}>{email.email}</li>)) : null}
                                            </ul>
                                            {formik.touched.partner && formik.errors.partner ? (
                                                <div className="text-danger pt-2">{formik.errors.partner}</div>
                                            ) : null}
                                            {formik.touched.partner_emails && formik.errors.partner_emails ? (
                                                <div className="text-danger pt-2">{formik.errors.partner_emails}</div>
                                            ) : null}
                                        </div>

                                        <ul className='custom-selected-value'>
                                            {selectedPartners ? selectedPartners.map((email, index) => (<li className='chip' key={index}>{email.email} {isPartnerDisabled ? null : <span onClick={() => onRemoveEmail(email)}><i className='fa fa-close ml-2'></i></span>} </li>)) : null}
                                        </ul>
                                    </div>
                                    <div className="col-lg-1 col-md-1 col-sm-1 mt-4 text-right">
                                        <div className="form-group pt-1">
                                            <button onClick={() => AddToPartnerEmail(currentPartnerEmail)} type='button' className='btn custom-btn-outline-info' disabled={currentPartnerEmail ? false : true}>Add</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-11 col-md-11 col-sm-11">
                                        <div className="form-group">
                                            <label htmlFor="title" className="control-label">Add members<span className='text-danger'>*</span></label>
                                            {/* <input type="text" name={'member_emails'} placeholder='Enter New Member Email' id="member_emails" className="form-control"  {...formik.getFieldProps('member_emails')} /> */}
                                            <Multiselect
                                                options={members}
                                                selectedValues={selectedMembers}
                                                onSelect={onSelectMembers}
                                                onRemove={onRemoveMembers}
                                                {...formik.getFieldProps('member_emails')}
                                                displayValue="email"
                                                showArrow={true}
                                            />
                                            {formik.touched.member_emails && formik.errors.member_emails ? (
                                                <div className="text-danger pt-2">{formik.errors.member_emails}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-lg-1 col-md-1 col-sm-1 mt-4 text-right">
                                        <div className="form-group pt-1">
                                        {user?.userType !== MEMBER ?  <button onClick={() => handleAddMemberShow()} type='button' className='btn custom-btn-outline-info'>Add</button> : null }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <label htmlFor="member" className="control-label">Members ({selectedMembers.length})</label>
                                        {selectedMembers && selectedMembers.map((member, index) => (
                                            <div key={index} className='row py-1'>
                                                <div className='col-lg-4 col-md-6 col-sm-8'>
                                                    <h6>{member.email}</h6>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-8 text-center'>
                                                    <h6>{member.status}</h6>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-8 text-right'>
                                                    {member.status === 'Accepted' ?
                                                        <>
                                                            <button type='button' disabled className='btn custom-btn-warning'>Email</button>
                                                        </> :
                                                        <>
                                                            <button type='button' className='btn custom-btn-outline-info' onClick={() => onResendInvite(member.id)}>Resend Invite</button>
                                                        </>}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-radius">
                            <div className="header card-header custum-bg-warning rounded">
                                <h2 className="text-white">References</h2>
                            </div>
                            <div className="body card-body-shadow">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="phone-ex" className="control-label">Select References</label>
                                            <Multiselect
                                                options={campaigns}
                                                selectedValues={selectedCampaigns}
                                                onSelect={onSelectReferences}
                                                onRemove={onRemoveReferences}
                                                {...formik.getFieldProps('campaigns')}
                                                displayValue="name"
                                                showArrow={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <label htmlFor="reference" className="control-label">Project References ({selectedCampaigns.length})</label>
                                        {selectedCampaigns && selectedCampaigns.map((reference, index) => (
                                            <div key={index} className='row py-1'>
                                                <div className='col-lg-4 col-md-6 col-sm-8'>
                                                    <h6> <Link to={`/schedule-details/${reference.id}`}>{reference.name}</Link></h6>
                                                </div>
                                                {/* <div className='col-lg-4 col-md-6 col-sm-8 text-center'>
                                                    <h6>{reference.status}</h6>
                                                </div> */}
                                                {/* <div className='col-lg-4 col-md-6 col-sm-8 text-right'>
                                                    {reference.status === 'Accepted' ?
                                                        <>
                                                            <button type='button' disabled className='btn custom-btn-warning'>Email</button>
                                                        </> :
                                                        <>
                                                            <button type='button' className='btn custom-btn-outline-info' onClick={() => onResendInvite(member.id)}>Resend Invite</button>
                                                        </>}
                                                </div> */}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='row px-2 pb-3 clearfix'>
                    {/* <div className='col-md-4 col-lg-6 col-sm-6'>
                        <button type="button" className='btn btn-outline-danger'><i className='icon-close'></i> Discard</button>
                    </div> */}
                    <div className='col-md-12 col-lg-12 col-sm-12  text-center'>
                        {user?.userType !== MEMBER ? <button className='btn button' disabled={loading ? true : false} type='submit'>Update brief</button> : ''}
                    </div>
                </div>
            </form>
            <AddMemberModal
                open={showAddAdminModal}
                close={handleAddAdminClose}
                data={selectedRowData}
                onLoad={members}
                deleteData={null}
            />
        </>
    );
};
export default Details;